import React from "react";
import { Route, Switch } from "react-router-dom";

import List from "./list";
import View from "./view";

export default function Index() {
  return (
    <Switch>
      <Route path="/code/:id" component={View} />
      <Route path="/code" component={List} />
    </Switch>
  );
}
